export default __webpack_public_path__ + "static/media/03.ac9507a0.png";